import Environment from '@cobliteam/react-environments';
import { createClient } from '@prismicio/client';
import type { AllDocumentTypes } from './types/herbie-dashboard.generated';

const env = Environment.getInstance().getEnvironment();

export const repositoryName = env.prismicRepositoryDashboard;

const client = createClient<AllDocumentTypes>(repositoryName, {
  // Since 2026-09-26 `herbie-dashboard.cdn.prismic.io` answers 403 AccessDenied while the origin serves normally; revert once Prismic fixes the CDN.
  documentAPIEndpoint: `https://${repositoryName}.prismic.io/api/v2`,
  routes: [
    { type: 'home_banner', path: '/home' },
    { type: 'login_page', path: '/login' },
  ],
});

export default client;
